/* eslint-disable max-len */
import React from 'react';

export const SearchIcon = props => (
  <svg height="24" viewBox="0 0 24 24" width="24" {...props}>
    <defs>
      <path
        id="SearchIcon"
        d="m15.6833148 14.599485 3.2650512 3.2650512c.0781049.0781049.0781049.2047379 0 .2828428l-.800987.800987c-.0781049.0781049-.2047379.0781049-.2828428 0l-3.2650512-3.2650512c-1.0066541.7767582-2.2685783 1.238813-3.6384211 1.238813-3.29220468 0-5.9610639-2.6688592-5.9610639-5.9610639 0-3.29220468 2.66885922-5.9610639 5.9610639-5.9610639 3.2922047 0 5.9610639 2.66885922 5.9610639 5.9610639 0 1.3698428-.4620548 2.631767-1.238813 3.6384211zm-4.7274107 1.2336532c2.693622 0 4.8772341-2.1836121 4.8772341-4.8772341 0-2.69362205-2.1836121-4.87723413-4.8772341-4.87723413-2.69362205 0-4.87723413 2.18361208-4.87723413 4.87723413 0 2.693622 2.18361208 4.8772341 4.87723413 4.8772341z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <use fill="currentColor" fillRule="nonzero" xlinkHref="#SearchIcon" />
    </g>
  </svg>
);
